<template>
  <Grid v-if="isComponentActive" gap="var(--r-space-md)">
    <Orders :orders="ordersInvoices" />
    <AdditionalOrders namespace="subscriptions" />
    <Invoices :invoices="ordersInvoices" @refresh="getOrdersInvoices" />
    <AdditionalInvoices namespace="subscriptions" />
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import AdditionalOrders from '@/reusable/additional-orders/AdditionalOrders'
import AdditionalInvoices from '@/reusable/additional-invoices/AdditionalInvoices'
import Orders from './components/orders/Orders'
import Invoices from './components/invoices/Invoices'

export default {
  components: {
    AdditionalOrders,
    AdditionalInvoices,
    Orders,
    Invoices
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    ordersInvoices: null,
    isComponentActive: false
  }),

  activated() {
    this.isComponentActive = true
    this.getOrdersInvoices()
  },

  deactivated() {
    this.isComponentActive = false
  },

  methods: {
    getOrdersInvoices() {
      apiTo.GET_SUBSCRIPTION_ORDERS_INVOICES(this.id).then(({ data }) => (this.ordersInvoices = data.result))
    }
  }
}
</script>
